// import { cloneDeep } from 'lodash'

const state = {
  email: ''
}

const getters = {
  getEmail: state => state.email
}

const mutations = {
  UPDATE_EMAIL: (state, string) => {
    state.email = string
  }
}

const actions = {
  updateEmail: ({ commit }, email) => {
    commit('UPDATE_EMAIL', email)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
